import React from 'react';
import { OverlayPanel } from 'primereact/overlaypanel';
import "./AppTopbarProfile.scss"

function capitalize(str) {
  return str ? str[0].toUpperCase() + str.slice(1).toLowerCase() : "";
}

export const AppTopbarProfile = React.forwardRef((props, ref) => {

    const name = capitalize(props.user?.prenom) + " " + capitalize(props.user?.nom);
    const structure = props.user?.structure?.institution?.libelle ?? "N/A";
    const userType = props.user?.typeUtilisateur?.replace("_", " ");
    
    return (
        <OverlayPanel
            ref={ref}
            appendTo={document.body}
            style={{ width: 'auto' }}
        >
            <div className="outer-div" style={{ margin: '-18px' }}>
                <div className="inner-div">
                    <div className="front">
                        <div className="front__bkg-photo"></div>
                        <div className="front__face-photo"></div>
                        <div className="front__text">
                            <h3 className="front__text-header">{name}</h3>
                            <p className="front__text-para"><i className="pi pi-check"></i>{" " + structure}</p>
                            <span className="front__text-hover">{userType}</span>
                        </div>
                    </div>
                </div>
            </div>
        </OverlayPanel>
    )
});
